import { Button, Col, Row } from "reactstrap";
import { ButtonBackgroundTitle, Href } from "../../../Constants/Constants";
import { ButtonBackgroundData } from "../../../Data/Bonus/Elements";

const ButtonBackground = () => {
  return (
    <section className="background">
      <Row>
        <Col xs="12">
          <div className="element-card">
            <div className="element-card-header heading">
              <h2>{ButtonBackgroundTitle}</h2>
            </div>
            <div className="element-card-body button-bg-color typography">
              {ButtonBackgroundData.map((item, index) => (
                <Button tag={"a"} color={item} key={index} className="button-effect fonts font_label" href={Href}>
                  btn-{item}
                </Button>
              ))}
            </div>
          </div>
        </Col>
      </Row>
    </section>
  );
};

export default ButtonBackground;
